import { render, staticRenderFns } from "./AuscultationsUploadsCard.vue?vue&type=template&id=168805c0&scoped=true&"
import script from "./AuscultationsUploadsCard.vue?vue&type=script&lang=js&"
export * from "./AuscultationsUploadsCard.vue?vue&type=script&lang=js&"
import style0 from "./AuscultationsUploadsCard.vue?vue&type=style&index=0&id=168805c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168805c0",
  null
  
)

export default component.exports